<li [class.expanded]="expanded">
  <a href="javascript:void(0)"
     (click)="item.submenu.length ? toggleExpand($event) : navigate(item.path)"
     [ngClass]="item.class"
     [class.expanded]="expanded">
    <i *ngIf="item.icon" [class]="item.icon"></i>
    <span>{{ item.title }}</span>
    <i *ngIf="item.submenu.length" class="bi" [class.bi-chevron-down]="!expanded" [class.bi-chevron-up]="expanded"></i>
  </a>

  <ul *ngIf="item.submenu.length" class="submenu" [class.show]="expanded">
    <app-rol-sidebar-item *ngFor="let child of item.submenu" [item]="child"></app-rol-sidebar-item>
  </ul>
</li>

<!-- <li>
  <a href="javascript:void(0)"
     (click)="item.submenu.length ? toggleExpand($event) : navigate(item.path)"
     [ngClass]="{ expanded: expanded }">
    <i *ngIf="item.icon" [class]="item.icon"></i>
    <span>{{ item.title }}</span>
    <i *ngIf="item.submenu.length"
       class="bi"
       [class.bi-chevron-down]="!expanded"
       [class.bi-chevron-up]="expanded"></i>
  </a>

  <ul *ngIf="item.submenu.length && expanded" class="submenu">
    <app-sidebar-item *ngFor="let child of item.submenu" [item]="child"></app-sidebar-item>
  </ul>
</li> -->
